'use client';

import { createTheme } from '@mui/material/styles';

export const theme = createTheme({
  palette: {
    mode: 'light',
    primary: {
      main: '#553C9A',
      light: '#6B46C1',
      dark: '#3c2579',
    },
    secondary: {
      main: '#E53E3E',
      light: '#F56565',
      dark: '#C53030',
    },
    background: {
      default: '#F7FAFC',
      paper: '#FFFFFF',
    },
  },
  typography: {
    fontFamily: '"Inter", "Roboto", "Helvetica", "Arial", sans-serif',
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: 'none',
          borderRadius: '8px',
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          borderRadius: '12px',
        },
      },
    },
  },
});

const darkTheme = createTheme({
  ...theme,
  palette: {
    mode: 'dark',
    primary: {
      main: '#9F7AEA',
      light: '#B794F4',
      dark: '#805AD5',
    },
    secondary: {
      main: '#F56565',
      light: '#FC8181',
      dark: '#E53E3E',
    },
    background: {
      default: '#1A202C',
      paper: '#2D3748',
    },
  },
});